import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Optional } from "@angular/core";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IGoogleMapsMarker, IGoogleMapsMarkerOptions } from "@interfaces/IGoogleMapsMarkerOptions";
import { MapService } from "@services/map.service";
import { ICommonMapComponent, VMapComponent } from "../v-map/v-map/v-map.component";

declare var MarkerWithLabel: any;

@Component({
    selector: "ui-gmap-marker",
    template: ""
})
export class UIGmapMarkerComponent implements OnChanges, OnDestroy, OnInit {

    @Input() marker: IGoogleMapsMarker<any>;

    // Deprecated
    @Input() idkey: any;
    @Input() coords: any;
    @Input() options: any;
    @Input() events: any;
    // Deprecated end

    veriMap: ICommonMapComponent;

    googleMarker: google.maps.Marker;

    constructor(
        @Optional() private readonly vMap: VMapComponent,
        private elementRef: ElementRef<HTMLElement>,
        private readonly mapService: MapService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(): void {
        if (this.idkey || this.coords || this.options) {
            console.error("Do not pass options into UIGmapMarkers", this.idkey, this.coords, this.options);
            console.log("Use Marker instead");
        }

        if (!this.veriMap) {
            this.veriMap = this.vMap || this.mapService.findVeriMap(this.elementRef);
        }

        this.veriMap.mapInitialisedPromise.then(map => {

            if (this.events) {
                console.warn("Marker doesnt support events at the moment");
            }

            if (!this.marker) {
                return;
            }

            if (!this.googleMarker) {
                this.googleMarker = new MarkerWithLabel(this.marker?.options || this.marker);
                this.googleMarker.setMap(this.veriMap.getMap());
            }
            else {
                this.googleMarker.setOptions(this.marker?.options);
            }

            // V Map specific
            if (this.vMap) {
                var position = this.marker.options?.position || (this.marker as IGoogleMapsMarkerOptions).position as any;

                this.vMap.fitMap([position]);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.googleMarker) {
            this.googleMarker.setMap(null);
        }
    }
}
